export default __webpack_public_path__ + "static/media/WhiteLogo.1fbe6857.png";